var render = function render(_c,_vm){return _c('div',{staticClass:"logo"},[(_vm.$options.methods.showLabel(_vm.parent))?_c('div',{staticClass:"logo__label"},[_vm._v("\n    by Baserow\n  ")]):_vm._e(),_vm._v(" "),_c('img',_vm._b({class:[_vm.data.staticClass, _vm.data.class],attrs:{"src":_vm.$options.methods.getLogoUrl(_vm.parent)}},'img',_vm.props,false))])
}
var staticRenderFns = []

export { render, staticRenderFns }